import React from 'react';

import { makeUclComponent } from '@rbilabs/universal-components';
import { StyleSheet } from 'react-native';
import type { ViewStyle } from 'react-native';

import Button, { ActionButtonVariants } from 'components/action-button';
import { Typography, TypographyProps, withTypography } from 'components/ui';
import { Box, BoxProps } from 'components/ui/box';
import { useIsDesktopBreakpoint } from 'hooks/use-media-query';
import { getDesignToken, layout, primitive, shadows, spacing } from 'styles/constants';

export const OrderIssuesContainer = ({ style, ...props }: BoxProps) => {
  const isDesktop = useIsDesktopBreakpoint();

  return React.createElement(Box, {
    focusable: true,
    ...props,
    style: [styles.orderIssuesContainer, isDesktop && styles.orderIssuesContainerDesktop, style],
  });
};

export const HeaderContainer = ({ style, ...props }: BoxProps) =>
  React.createElement(Box, {
    ...props,
    style: [styles.headerContainer, style],
  });

export const OrderIssuesDetails = ({ style, ...props }: BoxProps) => {
  const isDesktop = useIsDesktopBreakpoint();

  return React.createElement(Box, {
    ...props,
    style: [styles.orderIssuesDetails, isDesktop && styles.orderIssuesDetailsDesktop, style],
  });
};

export const OrderIssuesHeading = (props: TypographyProps) => {
  const isDesktop = useIsDesktopBreakpoint();

  return (
    <Typography
      textAlign={isDesktop ? 'left' : 'center'}
      mb={isDesktop ? '$2' : '$0'}
      variant="headerThree"
      fontSize="lg"
      {...props}
    />
  );
};

export const OrderIssuesText = withTypography({
  variant: 'bodyOne',
  style: {
    marginBottom: spacing.$4,
  },
});

export const StyledButtonContainer = ({ style, ...props }: BoxProps) =>
  React.createElement(Box, {
    ...props,
    style: [styles.styledButtonContainer, style],
  });

export const StyledButton = makeUclComponent(Button).withConfig({
  color: primitive.$fieryRed,
  fontSize: 'md',
  variant: ActionButtonVariants.OUTLINE,
  _hover: {
    color: primitive.$fieryRedHover,
  },
});

const styles = StyleSheet.create({
  headerContainer: {
    alignItems: 'flex-start',
    backgroundColor: primitive.$blackOpacity4,
    borderBottomColor: primitive.$blackOpacity10,
    borderBottomWidth: 1,
    paddingHorizontal: spacing.$4,
    paddingVertical: spacing.$4_5,
    width: layout.full,
  },
  orderIssuesContainer: {
    alignItems: 'center',
    backgroundColor: getDesignToken('background-card'),
    borderRadius: primitive.$borderRadius,
    flexDirection: 'column',
    justifyContent: 'space-between',
    marginTop: spacing.$4,
    minHeight: spacing.$6,
    overflow: 'hidden',
    width: layout.full,
  },
  orderIssuesContainerDesktop: {
    ...shadows.$1,
    flexDirection: 'row',
  } as ViewStyle,
  orderIssuesDetails: {
    paddingHorizontal: spacing.$4,
    paddingVertical: spacing.$4,
    width: layout.full,
  },
  orderIssuesDetailsDesktop: {
    flex: 2,
    paddingHorizontal: spacing.$6,
    paddingVertical: spacing.$6,
  },
  styledButtonContainer: {
    padding: spacing.$6,
  },
});
